import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Toast from './utils/toast'
import Confirm from './utils/confirm'
import './assets/css/global-fix.css'
import './assets/css/style.css'
import './assets/css/header.css'
import './assets/css/index.css'
import './assets/css/index2.css'
import './assets/css/footer.css'

Vue.config.productionTip = false
Vue.prototype.httpUrl = "https://houtai5698.koiodeal.com"
// 注册 Toast 插件
Vue.use(Toast)
// 注册 Confirm 插件
Vue.use(Confirm)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
